// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1U38Y","header":"ReportDetails_header__bD6bP","title":"ReportDetails_title__3xvKt","left":"ReportDetails_left__3oAKF"};